import { FirmUser, User } from '@/_types/models/user';

export const getFullName = (user?: User | FirmUser): string => {
  const hasBothNames: boolean = !!user?.fname && !!user?.lname;
  const fallbackName: string = hasBothNames
    ? `${user?.fname} ${user?.lname}`
    : '';

  return (
    (user as User)?.preferred_name ||
    (user as FirmUser)?.name ||
    fallbackName ||
    ''
  );
};
